<script>
import { clamp } from "./scale";

// Tooltip compartido por los gráficos: se coloca en coordenadas del contenedor
// (position:relative), se mantiene dentro de él y se voltea si no cabe arriba.
// Aparece con hover y con foco; nunca es la única vía de leer un valor (aria-hidden).
export default {
  name: "DashTip",
  props: {
    show: { type: Boolean, default: false },
    x: { type: Number, default: 0 },
    y: { type: Number, default: 0 },
    side: { type: String, default: "auto" }, // auto = arriba y se voltea si no cabe · top = siempre arriba
  },
  data() {
    return { w: 0, h: 0, pw: 0, dismissed: false };
  },
  computed: {
    flip() {
      return this.side === "auto" && this.h > 0 && this.y - this.h - 16 < 0;
    },
    style() {
      const half = this.w / 2 + 4;
      const left = this.pw > this.w + 8 ? clamp(this.x, half, this.pw - half) : this.x;
      return {
        left: `${left}px`,
        top: `${this.flip ? this.y + 18 : this.y - 12}px`,
        transform: this.flip ? "translate(-50%, 0)" : "translate(-50%, -100%)",
      };
    },
  },
  watch: {
    show(on) {
      // Descartable con Esc sin mover el puntero ni el foco (WCAG 1.4.13); reaparece al volver a entrar.
      this.dismissed = false;
      if (on) document.addEventListener("keydown", this.onKey);
      else document.removeEventListener("keydown", this.onKey);
      this.$nextTick(this.measure);
    },
    x() {
      this.$nextTick(this.measure);
    },
  },
  updated() {
    this.measure();
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKey);
  },
  methods: {
    onKey(e) {
      if (e.key === "Escape") this.dismissed = true;
    },
    measure() {
      const el = this.$el;
      if (!el || !el.parentNode) return;
      const w = el.offsetWidth;
      const h = el.offsetHeight;
      const pw = el.parentNode.clientWidth;
      if (w !== this.w) this.w = w;
      if (h !== this.h) this.h = h;
      if (pw !== this.pw) this.pw = pw;
    },
  },
};
</script>

<template>
  <div class="dsh-tip" :class="{ 'is-on': show && !dismissed }" :style="style" aria-hidden="true">
    <slot />
  </div>
</template>
